import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ButtonBase, Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Balance.BalanceContent;

type Props = {
  currency: string;
  currencyCount: number;
  onClick: () => void;
};

/**
 * "CZK · 3 měny ˅" under the mobile balance: names the currency on screen, says how many the
 * persona holds, and opens the currency sheet. Rendered only when there is something to switch to.
 */
export const CurrencyPill = ({ currency, currencyCount, onClick }: Props) => {
  const { t } = useResource();

  return (
    <ButtonBase
      onClick={onClick}
      aria-label={t(RESOURCES.CurrencySheetTitle)}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.5,
        px: 2.5,
        py: 1.5,
        borderRadius: 999,
        bgcolor: "rgba(255, 255, 255, 0.12)",
        color: "primary.contrastText",
      }}
    >
      <Typography fontWeight={700} component="span">
        {currency}
      </Typography>
      <Typography component="span" sx={{ opacity: 0.6 }}>
        ·
      </Typography>
      <Typography component="span" sx={{ opacity: 0.8 }}>
        {t(RESOURCES.CurrencyCount, { count: currencyCount })}
      </Typography>
      <ExpandMoreIcon fontSize="small" sx={{ opacity: 0.8 }} />
    </ButtonBase>
  );
};
